import enMessages from "./../lang/en-US.json"
import arMessages from "./../lang/ar-EG.json";
import hiMessages from "./../lang/hi-IN.json"

export const defaultLocale = "ar-EG"
export const locales = {
	"en-US": {
		messages: enMessages
	},
	"ar-EG": {
		messages: arMessages
	},
	"hi-IN": {
		messages: hiMessages
	},
};